import React from 'react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetHeaderCloseButton,
} from 'components/ModalSheet'
import { observer } from 'mobx-react'
import ScopeChangeRequestRejectDialogViewModel from './ScopeChangeRequestRejectDialogViewModel'
import { useBrandingSettings } from 'hooks/branding'
import Button from 'components/Button'
import { TextAreaContainer } from 'components/inputs'
import styles from './ScopeChangeRequestRejectDialogViewModel.sass'

interface ScopeChangeRequestRejectDialogProps {
  vm: ScopeChangeRequestRejectDialogViewModel
}

export default observer(function ScopeChangeRequestRejectDialog({
  vm,
}: ScopeChangeRequestRejectDialogProps) {
  const { corporateMode } = useBrandingSettings()

  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader>
        <div className={styles.closeButtonContainer}>
          <ModalSheetHeaderCloseButton dataTest="scope-change-request-close-reject-dialog" />
        </div>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={require('assets/images/img_missing-permissions.svg')}
              alt="Reject"
            />
          )}
          <ModalSheetContentTitle>
            Do you want to decline this change request?
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            You will need to provide a clear reason as to why the requested
            changes are declined.
          </ModalSheetContentDescription>
          <div className={styles.reasonContainer}>
            <label className={styles.reasonLabel}>Reason</label>
            <TextAreaContainer
              rows={4}
              model={vm}
              field="reason"
              name="reason"
              maxLength={vm.MAX_REASON_LENGTH}
              error={vm.validation.getError('reason')}
              status={vm.validation.getError('reason') ? 'danger' : 'default'}
              placeholder="This will be visible to everyone"
              help={`${vm.reasonCharsRemaining} characters remaining`}
              data-test="scope-change-request-decline-reason"
            />
          </div>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button onClick={vm.close} type="default">
            Close
          </Button>
          <Button
            onClick={vm.decline}
            type="danger"
            dataTest="scope-change-request-reject"
            loading={vm.decline.pending}
            disabled={vm.decline.pending}
          >
            Decline
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
